import React from 'react';
import styles from './style.module.css';

export default () => (
    <div className={styles.page}>
        <div className={styles.contentContainer}>
            <h1 className={styles.mainTitle}>Thank you!</h1>
            <p className={styles.text}>We’ve sent a copy of your assessment by email. Visit our homepage to discover more about our personalized coaching approach.</p>
            <a href='https://www.libro.ca/' className={styles.button} title='Visit Libro Credit Union homepage'>Visit homepage</a>
        </div>
    </div>
);
